import { useTranslation } from "react-i18next";
import "./Footer.css";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <>
<footer className="footer" id="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h3>{t("footer_contact")}</h3>
          <p><strong>{t("f_para1")}</strong></p>
          <p><strong>{t("f_para2")}</strong> +47-99862000</p>
          <p>
            <a href="mailto:post@listentodelhi.com">
              post@listentodelhi.com
            </a>
          </p>
          <p><strong>{t("f_para3")}</strong> Frognerveien 1, 0257, Oslo</p>

        </div>

        <div className="footer-column">
          <h3>{t("f_open_timings")}</h3>
          <p><strong>{t("f_para4")}:</strong> {t("f_para5")}</p>
          <p><strong>{t("f_para6")}:</strong> {t("f_para7")}</p>
          <p><strong>{t("f_para8")}:</strong> {t("f_para9")}</p>
          <p className="note">
          <strong>{t("f_para10")}</strong>
          </p>
          <p className="note">
            {t("f_para11")}
          </p>
          <p className="note">
            {t("f_para12")}
          </p>
        </div>

        <div className="footer-column map">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2000.025008411133!2d10.717586400000002!3d59.915132299999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46416d97cf4c044b%3A0x834faefb48909a2d!2sListen%20to%20Baljit!5e0!3m2!1sen!2sno!4v1769430135890!5m2!1sen!2sno" 
          title="Restaurant Location"
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;
